module.exports = __webpack_public_path__ + "static/media/02.f190ff6c.png";